/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DenoiserChannelFragment = {
	id: string;
	features: {
		name: { name: string } | null;
		denoiser: { enabled: boolean; level: Types.DenoiserLevel } | null;
		channelConfiguration: { enabled: boolean } | null;
	};
	description: {
		constraints: { denoiser: { level: { options: Array<Types.DenoiserLevel> } } | null };
		features: { channelConfiguration: { supported: boolean } };
	};
};

export type DenoiserChannelUpdateFragment = {
	id: string;
	features:
		| { channelConfiguration: { enabled: boolean } | null }
		| { denoiser: { enabled: boolean; level: Types.DenoiserLevel } | null }
		| { name: { name: string } | null }
		| {};
};

export type DenoiserChannelQueryVariables = Types.Exact<{
	channelId: Types.Scalars['ID']['input'];
}>;

export type DenoiserChannelQueryOpResult = { node: DenoiserChannelFragment | {} };

export type DenoiserChannelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type DenoiserChannelSubscriptionOpResult = {
	nodeChanges: DenoiserChannelFragment | DenoiserChannelUpdateFragment | {};
};

export type DenoiserChannelMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type DenoiserChannelMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export const DenoiserChannelFragment = gql`
	fragment DenoiserChannelFragment on AudioChannel {
		id
		features {
			name {
				name
			}
			denoiser {
				enabled
				level
			}
			channelConfiguration {
				enabled
			}
		}
		description {
			constraints {
				denoiser {
					level {
						options
					}
				}
			}
			features {
				channelConfiguration {
					supported
				}
			}
		}
	}
`;
export const DenoiserChannelUpdateFragment = gql`
	fragment DenoiserChannelUpdateFragment on AudioChannelChange {
		id
		features {
			... on AudioChannelNameChange {
				name {
					name
				}
			}
			... on AudioChannelDenoiserChange {
				denoiser {
					enabled
					level
				}
			}
			... on AudioChannelChannelConfigurationChange {
				channelConfiguration {
					enabled
				}
			}
		}
	}
`;
export const DenoiserChannelQueryDocument = gql`
	query DenoiserChannelQuery($channelId: ID!) {
		node(id: $channelId) {
			...DenoiserChannelFragment
		}
	}
	${DenoiserChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DenoiserChannelQueryGQL extends Apollo.Query<DenoiserChannelQueryOpResult, DenoiserChannelQueryVariables> {
	override document = DenoiserChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const DenoiserChannelSubscriptionDocument = gql`
	subscription DenoiserChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on AudioChannel {
				...DenoiserChannelFragment
			}
			... on AudioChannelChange {
				...DenoiserChannelUpdateFragment
			}
		}
	}
	${DenoiserChannelFragment}
	${DenoiserChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class DenoiserChannelSubscriptionGQL extends Apollo.Subscription<
	DenoiserChannelSubscriptionOpResult,
	DenoiserChannelSubscriptionVariables
> {
	override document = DenoiserChannelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const DenoiserChannelMutationDocument = gql`
	mutation DenoiserChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on AudioChannelOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class DenoiserChannelMutationGQL extends Apollo.Mutation<
	DenoiserChannelMutationOpResult,
	DenoiserChannelMutationVariables
> {
	override document = DenoiserChannelMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
